import React from "react";
import variables from "../styleVariables";

const TrendDownIcon = ({ color = variables.colorCancel }) => (
  <svg viewBox="0 0 24 24" className="trend-icon">
    <path fill={color} d="M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z" />
  </svg>
);

export default TrendDownIcon;
